export const hasPermission = (permissions: string[], id: string): boolean =>
  permissions.includes(id);

export const hasAny = (permissions: string[], ids: string[]): boolean =>
  ids.some(id => permissions.includes(id));

export const hasAll = (permissions: string[], ids: string[]): boolean =>
  ids.every(id => permissions.includes(id));

// Shallow order-insensitive equality for string arrays
export const arraysHaveSameContents = (a: string[], b: string[]): boolean => {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  const setA = new Set(a);
  const setB = new Set(b);
  if (setA.size !== setB.size) return false;
  for (const item of setA) if (!setB.has(item)) return false;
  return true;
};

